<nz-card>
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="ordered-list" nzTheme="outline"></i> Address of the Organization
  </div>

  <div class="searchboxAerar p-3">
    <div class="form-row" style="margin-left: 12px">
      <div class="form-group col-md-6">
        <nz-form-label class="text-weight">Name of STP</nz-form-label>
        <nz-form-label nzNoColon>{{ this.correctionRequestForm.get('prevStpName')?.value }}</nz-form-label>
      </div>

      <div class="form-group col-md-6">
        <nz-form-label class="text-weight">Name of STP in Bangla</nz-form-label>
        <nz-form-label nzNoColon>{{ this.correctionRequestForm.get('prevStpNameBangla')?.value }}</nz-form-label>
      </div>
    </div>

    <div class="form-row" style="margin-left: 12px">
      <div class="form-group col-md-4">
        <nz-form-label class="text-weight">Location of the STP</nz-form-label>
        <nz-form-label nzNoColon>{{ this.correctionRequestForm.get('prevLocation')?.value }}</nz-form-label>
      </div>

      <div class="form-group col-md-4">
        <nz-form-label class="text-weight">Country</nz-form-label>
        <nz-form-label nzNoColon>{{ this.correctionRequestForm.get('prevCountry')?.value }}</nz-form-label>
      </div>

      <div class="form-group col-md-4">
        <nz-form-label class="text-weight">Division/State</nz-form-label>
        <nz-form-label nzNoColon>{{ this.correctionRequestForm.get('prevDivision')?.value }}</nz-form-label>
      </div>
    </div>

    <div class="form-row" style="margin-left: 12px">
      <div class="form-group col-md-4">
        <nz-form-label class="text-weight">District/City</nz-form-label>
        <nz-form-label nzNoColon>{{ this.correctionRequestForm.get('prevDistrict')?.value }}</nz-form-label>
      </div>

      <div class="form-group col-md-4">
        <nz-form-label class="text-weight">Upazilla/Sub-district</nz-form-label>
        <nz-form-label nzNoColon>{{ this.correctionRequestForm.get('prevUpazila')?.value }}</nz-form-label>
      </div>

      <div class="form-group col-md-4">
        <nz-form-label class="text-weight">Post Office</nz-form-label>
        <nz-form-label nzNoColon>{{ this.correctionRequestForm.get('prevPostOffice')?.value }}</nz-form-label>
      </div>
    </div>

    <div class="form-row" style="margin-left: 12px">
      <div class="form-group col-md-12">
        <nz-form-label class="text-weight">House, Road, Village Area</nz-form-label>
        <nz-form-label nzNoColon class="wider-label">{{ this.correctionRequestForm.get('prevAddress')?.value }}</nz-form-label>
      </div>
    </div>
  </div>

  <br>

  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="form" nzTheme="outline"></i> Correction Application Form
  </div>

  <div class="searchboxAerar p-3">
    <form nz-form [formGroup]="correctionRequestForm">
      <div class="form-row" style="margin-left: 28px">
        <div class="col-md-6">
          <nz-form-label>Name of STP</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzValidatingTip="Validating..." [nzErrorTip]="stpNameErrorTpl">
                <input nz-input style="margin-left: -17px" formControlName="stpName" placeholder="STP Name">
                <ng-template #stpNameErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('pattern')">
                    Please input valid STP name !
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="col-md-6">
          <nz-form-label>Name of STP (Bangla)</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzValidatingTip="Validating..." [nzErrorTip]="stpNameBanglaErrorTpl">
                <input nz-input style="margin-left: -17px" formControlName="stpNameBangla" placeholder="STP Name (Bangla)">
                <ng-template #stpNameBanglaErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('pattern')">
                    Please input valid STP name (Bangla) !
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <nz-alert
        style="margin: 0 28px 16px"
        nzType="info"
        nzShowIcon
        nzMessage="The location and address of the STP can't be changed through a correction request. Only the STP name can be corrected."
      ></nz-alert>

      <div class="form-row" style="margin-left: 28px">
        <div class="col-md-4">
          <nz-form-label nzRequired>Location of the STP</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzErrorTip="Please select location !">
                <nz-select nzShowSearch nzAllowClear formControlName="locationId" nzPlaceHolder="Select Location"
                  class="row" (ngModelChange)="setCountriesByLocationTypeId()">
                  <nz-option
                    *ngFor="let location of stpLocations"
                    [nzValue]="location.id"
                    [nzLabel]="location.locationName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="col-md-4">
          <nz-form-label nzRequired>Country</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzErrorTip="Please select country !">
                <nz-select nzShowSearch nzAllowClear formControlName="countryId" nzPlaceHolder="Select Country"
                  class="row" (ngModelChange)="setDivisionByCountryId()">
                  <nz-option
                    *ngFor="let country of sysCountries"
                    [nzValue]="country.id"
                    [nzLabel]="country.countryName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="col-md-4">
          <nz-form-label nzRequired>Division/State</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzErrorTip="Please select division/state !">
                <nz-select nzShowSearch nzAllowClear formControlName="divisionId" nzPlaceHolder="Select Division"
                  class="row" (ngModelChange)="setDistrictInformation()">
                  <nz-option
                    *ngFor="let division of divisions"
                    [nzValue]="division.id"
                    [nzLabel]="division.divisionName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-row" style="margin-left: 28px">
        <div class="col-md-4">
          <nz-form-label nzRequired>District/City</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzErrorTip="Please select district/city !">
                <nz-select nzShowSearch nzAllowClear formControlName="districtId" nzPlaceHolder="Select District"
                  class="row" (ngModelChange)="setStpUpazillaInformation()">
                  <nz-option
                    *ngFor="let district of districts"
                    [nzValue]="district.id"
                    [nzLabel]="district.districtName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="col-md-4">
          <nz-form-label nzRequired>Upazilla/Sub-district</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzErrorTip="Please select upazilla !">
                <nz-select nzShowSearch nzAllowClear formControlName="upazilaId" nzPlaceHolder="Select Upazilla" class="row">
                  <nz-option
                    *ngFor="let upazilla of upazilas"
                    [nzValue]="upazilla.id"
                    [nzLabel]="upazilla.upazillaName">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="col-md-4">
          <nz-form-label nzRequired>Post Office</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzValidatingTip="Validating..." [nzErrorTip]="postOfficeErrorTpl">
                <input nz-input style="margin-left: -17px" formControlName="postOffice" placeholder="Post Office">
                <ng-template #postOfficeErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input post office !
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-row" style="margin-left: 28px">
        <div class="col-md-12">
          <nz-form-label nzRequired>House, Road, Village Area</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzValidatingTip="Validating..." [nzErrorTip]="addressErrorTpl">
                <textarea nz-input style="margin-left: -17px" formControlName="address" placeholder="Address"></textarea>
                <ng-template #addressErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input address !
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="row justify-content-center media-button">
        <div class="col-xs-6 col-sm-4">
          <button
          type="button"
          [disabled]="!correctionRequestForm.valid"
          class="btn btn-success active btn-lg btn-block cari border-redius"
          nz-popconfirm
          nzPopconfirmTitle="Are you sure to save this correction request application?"
          (nzOnConfirm)="saveCorrectionRequestInfo()"><i nz-icon nzType="save" nzTheme="fill"></i> Save
          </button>
        </div>

        <div class="col-xs-6 col-sm-4" *ngIf="!this.setupInfo?.isPaymentApplicable">
          <button
          type="button"
          [disabled]="!this.isSubmitButtonEnable"
          class="btn btn-success active btn-lg btn-block cari border-redius"
          nz-popconfirm
          nzPopconfirmTitle="Are you sure to submit this correction request application?"
          (nzOnConfirm)="submitCorrectionRequestInfo()"><i nz-icon nzType="save" nzTheme="fill"></i> Submit
          </button>
        </div>

        <div class="col-xs-6 col-sm-4" *ngIf="this.setupInfo?.isPaymentApplicable">
          <button
          type="button"
          [disabled]="!this.isSubmitButtonEnable"
          class="btn btn-success active btn-lg btn-block cari border-redius"
          nz-popconfirm
          nzPopconfirmTitle="{{ this.paymentMessage }}"
          (nzOnConfirm)="onlinePaymentforStpCorrectionRequest()">
          <i nz-icon nzType="save" nzTheme="fill"></i> Pay Online & Submit
          </button>
        </div>
      </div>

      <br>
    </form>
  </div>
</nz-card>
